export default __webpack_public_path__ + "13a0af51e231da8952b2ce5d8e47811a.svg";